import {
  SET_USER,
  SET_STRIPLE_TOKEN,
  SET_STRIPE_CLIENTSECRET,
  SET_STRIPE_CUSTOMERSESSION_CLIENTSECRET
} from "../actions/const";

const initialState = {
  user: null,
  isLoaded: false,
  stripeCards: null,
  clientSecret: 'initial',
  clientSecretCust: 'initial_cust'
};

const getToken = (token) => {
  const result = [];

  for(let key in token) {
    if (token.hasOwnProperty(key)) {
      result.push(token[key]);
    }
  }

  return result;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {...state, user: action.payload, isLoaded: true};
    case SET_STRIPLE_TOKEN:
      return {...state, stripeCards: getToken(action.payload)};
    case SET_STRIPE_CLIENTSECRET:
      return {...state, clientSecret: action.payload};
    case SET_STRIPE_CUSTOMERSESSION_CLIENTSECRET:
      return {...state, clientSecretCust: action.payload};
    default:
      return state;
  }
};
